import React from 'react';
import InpageBase from './InpageBase';

import TInpage from './types/TInpage';
import { FeedbackSignals } from '../../types/TEFeedbackSignal';

const Error = (props: TInpage) => <InpageBase {...props} signal={FeedbackSignals.Error} />;

export default Error;
